<div class="container" [formGroup]="form">
  <qai-item-grid
    [repeatCount]="'auto-fit'"
    [gap]="'12px'"
    [minItemWidth]="'200px'"
  >
    <qai-field [label]="'Assignment type'">
      <qai-floating-select
        [options]="assignmentTypeOptions"
        [placeholder]="'Select Assignment type'"
        [placement]="'below-start'"
        [offset]="4"
        [shape]="'rectangle'"
        [value]="form.get('moduleAssignmentType')?.value"
        (selectionChange)="
          form.get('moduleAssignmentType')?.setValue($event?.value)
        "
        [disabled]="readOnly"
      ></qai-floating-select>
    </qai-field>

    <qai-field
      [label]="'Name'"
      [error]="
        isAssignmentNameAlreadyExists
          ? 'Assignment with this name already exists'
          : ''
      "
    >
      <input
        qai-input
        type="text"
        [placeholder]="'Assignment name'"
        formControlName="moduleAssignmentName"
      />
    </qai-field>

    @if (isNewAssignment) {
      <qai-field [label]="'Product'">
        <qai-floating-select
          [options]="productOptions"
          [placeholder]="'Select Product'"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [value]="form.get('moduleUuid')?.value"
          (selectionChange)="form.get('moduleUuid')?.setValue($event?.value)"
          [disabled]="readOnly"
          [searchable]="true"
          [showActionButton]="true"
          [actionButtonLabel]="'Add new product'"
          (action)="onAddNewProduct($event)"
        ></qai-floating-select>
      </qai-field>
    }

    <qai-field
      [label]="'Passing score' + (isCertificationType() ? '' : ' (optional)')"
      [error]="
        form.get('scoreCriteria')?.hasError('maxExceeded')
          ? 'Score should not exceed 5'
          : ''
      "
    >
      <input
        qai-input
        type="number"
        formControlName="scoreCriteria"
        min="0"
        max="5"
        [disabled]="readOnly"
      />

      <button
        #floatingRefHelp
        qaiSlot="endIcon"
        qai-icon-button
        icon="help-circle"
        kind="quaternary"
      >
        Get help
      </button>
    </qai-field>

    <qai-tooltip
      [qaiFloating]="floatingRefHelp.el.nativeElement"
      [placement]="'above-end'"
      [events]="['hover']"
      [style.maxWidth]="'320px'"
    >
      This sets the overall score that a learner must achieve in order to pass
      the simulation.
    </qai-tooltip>
  </qai-item-grid>

  @if (!shouldHideFieldsForPersonalizedPractice()) {
    <qai-field [label]="'Description'">
      <textarea
        qai-textarea
        autosize
        [maxLines]="5"
        [placeholder]="'Assignment description'"
        formControlName="description"
      ></textarea>
    </qai-field>
  }

  <qai-item-grid
    [repeatCount]="'auto-fit'"
    [gap]="'45px'"
    [minItemWidth]="'200px'"
  >
    @if (!shouldHideFieldsForPersonalizedPractice()) {
      <qai-field [label]="''">
        <span qaiSlot="label" class="label-with-icon">
          <span>Messaging feedback</span>
          <button #floatingRef type="button" class="trailing-icon-button">
            <qai-icon [kind]="'help-circle'" size="16px" />
          </button>

          <qai-tooltip
            [qaiFloating]="floatingRef"
            [placement]="'below-start'"
            [events]="['hover']"
            [style.maxWidth]="'320px'"
          >
            <div class="tooltip-heading">Messaging Feedback</div>
            When a learner incorrectly states a message, they are shown
            information about how to better verbalize it the next time. This
            setting toggles whether that information is shown or not.
          </qai-tooltip>
        </span>

        <qai-toggle-switch-wrapper
          [checked]="showMissedFactsChecked"
          (checkedChange)="onshowMissedFactsChange($event)"
          enabledText="Enabled"
          disabledText="Disabled"
          size="small"
          shape="rectangle"
          [border]="true"
          weight="normal"
          kind="primary"
        ></qai-toggle-switch-wrapper>
      </qai-field>

      <qai-field [label]="'Pause button'">
        <qai-toggle-switch-wrapper
          [checked]="pauseEnabledChecked"
          (checkedChange)="onPauseEnabledChange($event)"
          enabledText="Enabled"
          disabledText="Disabled"
          size="small"
          shape="rectangle"
          [border]="true"
          weight="normal"
          kind="primary"
          [disabled]="readOnly"
        ></qai-toggle-switch-wrapper>
      </qai-field>

      <qai-field [label]="'Hide results'">
        <qai-toggle-switch-wrapper
          [checked]="hideResultsForLearnersChecked"
          (checkedChange)="onHideResultsForLearnersChange($event)"
          enabledText="Enabled"
          disabledText="Disabled"
          size="small"
          shape="rectangle"
          [border]="true"
          weight="normal"
          kind="primary"
        ></qai-toggle-switch-wrapper>
      </qai-field>
    }

    <qai-field [label]="'Assignment start date'">
      <qai-datepicker
        [startIcon]="'calendar'"
        [disabled]="false"
        [placeholder]="'Select date'"
        [kind]="'secondary'"
        [shape]="'normal'"
        [size]="'large'"
        [minDate]="minStartDate"
        [value]="form.get('startDate')?.value"
        (valueChange)="onDateChange('startDate', $event)"
        [disabled]="readOnly"
      ></qai-datepicker>
    </qai-field>

    <qai-field
      [label]="'Assignment end date' + (isCertificationType() ? '' : ' (optional)')"
      [error]="endDateErrorMessage"
    >
      <qai-datepicker
        [startIcon]="'calendar'"
        [disabled]="false"
        [placeholder]="'Select date'"
        [kind]="'secondary'"
        [shape]="'normal'"
        [size]="'large'"
        [minDate]="minEndDate"
        [value]="form.get('endDate')?.value"
        (valueChange)="onDateChange('endDate', $event)"
      ></qai-datepicker>
    </qai-field>
  </qai-item-grid>
</div>
